export default () => ({
    root: {
        width: '100%',
    },
    button: {
        marginLeft: 170,
    },
});
